import constant from "../../constant";
const resource = constant.api + "sections";

const state = {
  categories: {},
};

// getters
const getters = {
  getAll: (state) => {
    return state.categories;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    const data = await this._vm.$api.fetch(resource);
    commit("setAll", data);
  },

  async getItems({ commit }, section_reference) {
    const data = await this._vm.$api.fetch(
      `${resource}/items/${section_reference}`
    );
    commit("product/setAll", data, { root: true });
  },
};

// mutations
const mutations = {
  setAll(state, data) {
    state.categories = data?.data || data || [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
